module.exports = __webpack_public_path__ + "static/media/camille-gilbert-couch.519486c8.png";